import React from "react";
import { docsColors } from "@/lib/docs-theme";

interface DocSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export default function DocSection({ title, children, className = "" }: DocSectionProps) {
  return (
    <section className={`mb-12 ${className}`}>
      {title && (
        <h2 className={`text-2xl font-semibold ${docsColors.text.heading} mb-4`}>{title}</h2>
      )}
      {children}
    </section>
  );
}
